import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {
  Home,
  WaitingAespa,
  WaitingRiize,
  WaitingQueue,
  EnterCode,
  SelectCharacter,
  Play,
  Expired,
  Error,
} from "../pages";
import {path} from "./path";
import {ARTIST} from "../utils/artist.utils";
import {RouteGuard, LaunchDateGuard} from "src/services/session";
import {ErrorBoundary} from "src/components";

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={path.home(ARTIST.riize)} replace />}
        />
        <Route path={path.home(ARTIST.riize)} element={<Home />} />
        <Route path={path.home(ARTIST.aespa)} element={<Home />} />
        <Route path={path.waiting(ARTIST.riize)} element={<WaitingRiize />} />
        <Route path={path.waiting(ARTIST.aespa)} element={<WaitingAespa />} />
        <Route
          path={path.waitingQueue(ARTIST.riize)}
          element={<LaunchDateGuard><ErrorBoundary><WaitingQueue /></ErrorBoundary></LaunchDateGuard>}
        />
        <Route
          path={path.waitingQueue(ARTIST.aespa)}
          element={<LaunchDateGuard><ErrorBoundary><WaitingQueue /></ErrorBoundary></LaunchDateGuard>}
        />
        <Route
          path={path.code(ARTIST.riize)}
          element={
            <LaunchDateGuard>
              <RouteGuard redirectTo={path.waiting(ARTIST.riize)}>
                <ErrorBoundary>
                  <EnterCode />
                </ErrorBoundary>
              </RouteGuard>
            </LaunchDateGuard>
          }
        />
        <Route
          path={path.code(ARTIST.aespa)}
          element={
            <LaunchDateGuard>
              <RouteGuard redirectTo={path.waiting(ARTIST.aespa)}>
                <ErrorBoundary>
                  <EnterCode />
                </ErrorBoundary>
              </RouteGuard>
            </LaunchDateGuard>
          }
        />
        <Route
          path={path.character(ARTIST.riize)}
          element={
            <LaunchDateGuard>
              <RouteGuard redirectTo={path.waiting(ARTIST.riize)}>
                <ErrorBoundary>
                  <SelectCharacter />
                </ErrorBoundary>
              </RouteGuard>
            </LaunchDateGuard>
          }
        />
        <Route
          path={path.character(ARTIST.aespa)}
          element={
            <LaunchDateGuard>
              <RouteGuard redirectTo={path.waiting(ARTIST.aespa)}>
                <ErrorBoundary>
                  <SelectCharacter />
                </ErrorBoundary>
              </RouteGuard>
            </LaunchDateGuard>
          }
        />
        <Route
          path={path.play(ARTIST.riize)}
          element={
            <LaunchDateGuard>
              <RouteGuard redirectTo={path.waiting(ARTIST.riize)}>
                <ErrorBoundary>
                  <Play />
                </ErrorBoundary>
              </RouteGuard>
            </LaunchDateGuard>
          }
        />
        <Route
          path={path.play(ARTIST.aespa)}
          element={
            <LaunchDateGuard>
              <RouteGuard redirectTo={path.waiting(ARTIST.aespa)}>
                <ErrorBoundary>
                  <Play />
                </ErrorBoundary>
              </RouteGuard>
            </LaunchDateGuard>
          }
        />
        <Route
          path={path.expired(ARTIST.riize)}
          element={<LaunchDateGuard><Expired /></LaunchDateGuard>}
        />
        <Route
          path={path.expired(ARTIST.aespa)}
          element={<LaunchDateGuard><Expired /></LaunchDateGuard>}
        />
        <Route path={path.error(ARTIST.riize)} element={<Error />} />
        <Route path={path.error(ARTIST.aespa)} element={<Error />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
